import { ComponentProps, FC, PropsWithChildren } from 'react';
import { Typography, TypographyProps } from 'antd';

import { COLORS } from '../constants/colors';

const { Title: AntTitle } = Typography;

type WeightProps = {
  bold?: boolean;
  semibold?: boolean;
};

type TitleProps = PropsWithChildren<Partial<ComponentProps<TypographyProps['Title']>>> &
  WeightProps & {
    size?: 14 | 16 | 18 | 22 | 28;
  };

const getWeight = (weight: WeightProps): number => {
  switch (true) {
    case weight.semibold:
      return 600;
    case weight.bold:
      return 700;
    default:
      return 400;
  }
};

export const Title: FC<TitleProps> = ({ style, children, size, semibold, bold, ...props }) => (
  <AntTitle
    style={{
      color: COLORS.systemDark300,
      ...style,
      fontFamily: 'Manrope',
      fontSize: size,
      fontWeight: getWeight({ semibold, bold }),
    }}
    {...props}
  >
    {children}
  </AntTitle>
);
